import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { WhitepaperspageService } from 'src/app/features/company/resources/white-papers-and-reports/whitepaperspage.service';

@Injectable({
  providedIn: 'root',
})
export class WhitepaperArticleResolver implements Resolve<Entry<any>[]> {
  constructor(private whitePaperspageService: WhitepaperspageService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    return this.whitePaperspageService.getWhitepaperArticleByID(
      route.paramMap.get('whitepaperid')
    );
  }
}
